/* The source PNG contains a grey first pixel column. Mask that source fringe
   wherever this photo is displayed, including resized CDN URLs and the zoom. */
(() => {
  const asset='bloody-mary-la-cabane-de-la-glisse-trottinette-complete-versatyle-gris-noir-2.png';
  const observed=new WeakSet();
  function update(img){
    if(!decodeURIComponent(img.currentSrc||img.src||'').includes(asset)){
      if(img.dataset.cleanMediaEdge){img.style.removeProperty('clip-path');delete img.dataset.cleanMediaEdge;}return;
    }
    if(!img.naturalWidth||!img.clientWidth)return;
    const css=getComputedStyle(img),left=parseFloat(css.paddingLeft)||0,right=parseFloat(css.paddingRight)||0,top=parseFloat(css.paddingTop)||0,bottom=parseFloat(css.paddingBottom)||0;
    const width=img.clientWidth-left-right,height=img.clientHeight-top-bottom;
    const scale=css.objectFit==='contain'?Math.min(width/img.naturalWidth,height/img.naturalHeight):css.objectFit==='cover'?Math.max(width/img.naturalWidth,height/img.naturalHeight):width/img.naturalWidth;
    const inset=Math.max(0,left+(width-img.naturalWidth*scale)/2)+Math.max(1,2*scale);
    img.style.clipPath=`inset(0 0 0 ${inset}px)`;img.dataset.cleanMediaEdge='true';
  }
  const resize=new ResizeObserver(entries=>entries.forEach(({target})=>update(target)));
  function scan(root){
    const images=root.matches?.('img')?[root]:[...root.querySelectorAll?.('img')||[]];
    for(const img of images){if(!observed.has(img)){observed.add(img);img.addEventListener('load',()=>update(img));resize.observe(img);}update(img);}
  }
  scan(document);
  new MutationObserver(records=>{for(const r of records){if(r.type==='attributes')update(r.target);else for(const node of r.addedNodes)if(node.nodeType===1)scan(node);}}).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset']});
})();
